<script>
import {
  required,
} from "vuelidate/lib/validators";

export default {
    page: {
        title: "Panel İşlemleri",
    },
    data() {
        return {
            submitted:false,
            form:{},
            info:{}
        };
    },
    validations: {
        form:{
            oldpassword: { required },
            newpassword: { required },
        },
        info:{
            name: { required },
            phonenumber: { required },
            authorized_tc: { required },
            authorized_name: { required },
            address: { required },
        }
    },
    mounted() { this.getInfo() },
    methods: {
        getInfo(){
            this.$http.get(`/users/infoGet`)
            .then(response => this.info = response.data )
        },

        portalTransaction() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            } else {
               this.$http.put(`/users/infoSet`, this.form)
            }
            this.submitted = false;
        },
        infoTransaction() {
            this.submitted = true;
            this.$v.info.$touch();
            if (this.$v.info.$invalid) {
                return;
            } else {
               this.$http.put(`/users/infoSet`, this.info)
            }
            this.submitted = false;
        },
    }
};
</script>

<template>
<div class="row">
    <div class="col-md-7">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <form class="needs-validation" @submit.prevent="infoTransaction">
                        <div class="md-6">
                            <b-form-group
                                class="mb-3"
                                label="Yetkili İsim Soyisim"
                                label-cols-sm="3"
                            >
                                <b-form-input
                                    v-model="info.authorized_name"
                                    type="text"
                                    placeholder="Yetkili İsim Soyisim" 
                                    :class="{
                                        'is-invalid': submitted && $v.info.authorized_name.$error,
                                    }"
                                ></b-form-input>
                                <div
                                    v-if="submitted && $v.info.authorized_name.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.info.authorized_name.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Yetkili TC"
                                label-cols-sm="3"
                            >
                                <b-form-input
                                    v-model="info.authorized_tc"
                                    type="text"
                                    placeholder="Yetkili TC" 
                                    :class="{
                                        'is-invalid': submitted && $v.info.authorized_tc.$error,
                                    }"
                                ></b-form-input>
                                <div
                                    v-if="submitted && $v.info.authorized_tc.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.info.authorized_tc.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                        <b-form-group
                            class="mb-3"
                            label="Yetkili Telefon"
                            label-cols-sm="3"
                        >
                            <b-form-input
                                v-model="info.phonenumber"
                                type="text"
                                placeholder="Yetkili Telefon" 
                                :class="{
                                    'is-invalid': submitted && $v.info.phonenumber.$error,
                                }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.info.phonenumber.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.info.phonenumber.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        <b-form-group
                            class="mb-3"
                            label="Firma Unvan"
                            label-cols-sm="3"
                        >
                            <b-form-input
                                v-model="info.name"
                                type="text"
                                placeholder="Firma Unvan" 
                                :class="{
                                    'is-invalid': submitted && $v.info.name.$error,
                                }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.info.name.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.info.name.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        <b-form-group
                            class="mb-3"
                            label="Firma Adres"
                            label-cols-sm="3"
                            >
                            <b-form-input
                                v-model="info.address"
                                type="text"
                                placeholder="Firma Adres"
                                :class="{
                                    'is-invalid': submitted && $v.info.address.$error,
                                }"
                            >
                            </b-form-input>
                            <div
                                v-if="submitted && $v.info.address.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.info.address.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3 d-flex justify-content-end">
                                <button class="btn btn-warning" type="submit">Güncelle</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-5">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <form class="needs-validation" @submit.prevent="portalTransaction">
                    <div class="md-6">
                        <b-form-group
                            class="mb-3"
                            label="Şuanki Şifreniz"
                            label-cols-sm="5"
                        >
                            <b-form-input
                                v-model="form.oldpassword"
                                type="text"
                                placeholder="Şuanki Şifreniz" 
                                :class="{
                                    'is-invalid': submitted && $v.form.oldpassword.$error,
                                }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.form.oldpassword.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.oldpassword.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        <b-form-group
                            class="mb-3"
                            label="Yeni Şifreniz"
                            label-cols-sm="5"
                            >
                            <b-form-input
                                v-model="form.newpassword"
                                type="text"
                                placeholder="Yeni Şifreniz"
                                :class="{
                                    'is-invalid': submitted && $v.form.newpassword.$error,
                                }"
                            >
                            </b-form-input>
                            <div
                                v-if="submitted && $v.form.newpassword.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.newpassword.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3 d-flex justify-content-end">
                                <button class="btn btn-warning" type="submit">Güncelle</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>